// Generado desde design-system/components/feedback/feedback-styles.ts — no editar; edita el .ts/.tsx y corre build-ds.
import { injectStyles, SPRING_LINEAR } from '../motion/motion-utils';
/*
 * Hoja de estilos de la familia feedback: keyframes y @property que Tailwind
 * no puede expresar. Todo sale de tokens (var(--db-*)); sin hex sueltos.
 * Se inyecta una sola vez al importar cualquier componente de la familia.
 * Animaciones: solo transform / opacity (y clip-path en elementos pequeños).
 */
const CSS = `
:root { --dbm-spring: var(--db-ease-spring); }
@supports (transition-timing-function: linear(0, 1)) { :root { --dbm-spring: ${SPRING_LINEAR}; } }

/* ── Skeleton con brillo ─────────────────────────────────────────── */
:root, [data-theme="light"] {
  --dbf-skel-bg: color-mix(in srgb, var(--db-ink) 8%, transparent);
  --dbf-skel-hi: color-mix(in srgb, var(--db-surface-hi) 75%, transparent);
}
[data-theme="dark"] {
  --dbf-skel-bg: color-mix(in srgb, var(--db-ink) 9%, transparent);
  --dbf-skel-hi: color-mix(in srgb, var(--db-ink) 10%, transparent);
}
.dbf-skel { position: relative; overflow: hidden; isolation: isolate; background: var(--dbf-skel-bg); }
.dbf-skel::after {
  content: ""; position: absolute; inset: 0; pointer-events: none;
  background: linear-gradient(100deg, transparent 20%, var(--dbf-skel-hi) 50%, transparent 80%);
  transform: translateX(-100%);
  animation: dbf-shimmer 1.6s var(--db-ease-out) infinite;
  animation-delay: var(--dbf-delay, 0s);
}
@keyframes dbf-shimmer { 0% { transform: translateX(-100%); } 70%, 100% { transform: translateX(100%); } }

/* ── Barra indeterminada ─────────────────────────────────────────── */
.dbf-indet > i {
  position: absolute; inset: 0 auto 0 0; width: 42%; border-radius: inherit;
  background: linear-gradient(90deg, transparent, var(--db-accent) 30%, var(--db-accent) 70%, transparent);
  animation: dbf-indet 1.5s var(--db-ease-out) infinite;
}
@keyframes dbf-indet { 0% { transform: translateX(-105%); } 100% { transform: translateX(245%); } }

/* ── Cuenta regresiva del toast (se pausa con hover/foco) ─────────── */
.dbf-countdown { transform-origin: left center; animation: dbf-countdown linear forwards; }
@keyframes dbf-countdown { from { transform: scaleX(1); } to { transform: scaleX(0); } }

/* ── Puntos "escribiendo" ────────────────────────────────────────── */
.dbf-dots > i { display: block; width: 6px; height: 6px; border-radius: 999px; background: currentColor; opacity: .45;
  animation: dbf-dot 1.2s var(--db-ease-out) infinite; }
.dbf-dots > i:nth-child(2) { animation-delay: .16s; }
.dbf-dots > i:nth-child(3) { animation-delay: .32s; }
@keyframes dbf-dot { 0%, 60%, 100% { transform: translateY(0); opacity: .4; } 30% { transform: translateY(-4px); opacity: 1; } }

/* ── Cursor del texto en streaming ───────────────────────────────── */
.dbf-caret { display: inline-block; width: 2px; height: 1.05em; margin-left: 2px; vertical-align: -0.15em;
  background: var(--db-accent); border-radius: 2px; animation: dbf-caret 1s steps(1) infinite; }
@keyframes dbf-caret { 50% { opacity: 0; } }

/* ── Entradas cortas ─────────────────────────────────────────────── */
.dbf-rise { animation: dbf-rise var(--db-dur-base) var(--db-ease-out) both; }
@keyframes dbf-rise { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
.dbf-pop { animation: dbf-pop var(--db-dur-open) var(--dbm-spring) both; }
@keyframes dbf-pop { from { opacity: 0; transform: scale(.6); } to { opacity: 1; transform: none; } }
.dbf-shake { animation: dbf-shake .42s var(--db-ease-out); }
@keyframes dbf-shake { 0%, 100% { transform: none; } 20% { transform: translateX(-6px); } 40% { transform: translateX(5px); } 60% { transform: translateX(-3px); } 80% { transform: translateX(2px); } }
.dbf-breathe { animation: dbf-breathe 2.4s ease-in-out infinite; }
@keyframes dbf-breathe { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.04); } }
.dbf-ping { animation: dbf-ping 1.6s var(--db-ease-out) infinite; }
@keyframes dbf-ping { 0% { transform: scale(1); opacity: .55; } 80%, 100% { transform: scale(2.4); opacity: 0; } }
.dbf-draw { stroke-dasharray: 1; stroke-dashoffset: 1; animation: dbf-draw .5s var(--db-ease-out) .12s forwards; }
@keyframes dbf-draw { to { stroke-dashoffset: 0; } }

/* ── Botón de exportar con relleno líquido (motion-ui 6.8) ───────── */
@property --dbf-p { syntax: '<number>'; inherits: true; initial-value: 0; }
.dbf-liquid { --dbf-p: 0; transition: --dbf-p .7s var(--db-ease-out), transform var(--db-dur-base) var(--dbm-spring); }
.dbf-liquid[data-indeterminate="true"] { animation: dbf-slosh 2.4s ease-in-out infinite; }
@keyframes dbf-slosh { 0%, 100% { --dbf-p: .3; } 50% { --dbf-p: .62; } }
.dbf-liquid__fill { transform: translateY(calc((1 - var(--dbf-p)) * 100%)); }
.dbf-liquid__counter { transform: translateY(calc((var(--dbf-p) - 1) * 100%)); }
.dbf-liquid__meniscus { transform-origin: 50% 100%; transform: scaleY(calc(4 * var(--dbf-p) * (1 - var(--dbf-p)))); }
.dbf-liquid__label { transition: opacity .3s var(--db-ease-out), transform .55s var(--db-ease-out), filter .3s var(--db-ease-out); }
.dbf-liquid__label[data-pos="before"] { opacity: 0; transform: translateY(70%); filter: blur(3px); }
.dbf-liquid__label[data-pos="after"] { opacity: 0; transform: translateY(-70%); filter: blur(3px); }
.dbf-liquid__stem, .dbf-liquid__leg { transform-box: view-box; transition: transform .55s var(--db-ease-out), opacity .3s var(--db-ease-out); }
.dbf-liquid__leg { transform-origin: 12px 16px; }
.dbf-liquid[data-state="work"] .dbf-liquid__stem { transform: translateY(-14px); opacity: 0; }
.dbf-liquid__tray { opacity: .55; transition: opacity .3s var(--db-ease-out); }
.dbf-liquid[data-state="work"] .dbf-liquid__tray { opacity: 0; }
.dbf-liquid[data-state="work"] .dbf-liquid__leg--l { transform: rotate(-45deg); }
.dbf-liquid[data-state="work"] .dbf-liquid__leg--r { transform: rotate(45deg); }
.dbf-liquid[data-state="done"] .dbf-liquid__arrow, .dbf-liquid[data-state="error"] .dbf-liquid__arrow { opacity: 0; transform: scale(.6); }
.dbf-liquid__arrow { transform-box: view-box; transform-origin: 12px 12px; transition: opacity .25s var(--db-ease-out), transform .4s var(--db-ease-out); }
.dbf-liquid__check { stroke-dasharray: 1; stroke-dashoffset: 1; transition: stroke-dashoffset .45s var(--db-ease-out) .15s; }
.dbf-liquid[data-state="done"] .dbf-liquid__check { stroke-dashoffset: 0; }

@media (prefers-reduced-motion: reduce) {
  .dbf-skel::after { animation: none; opacity: 0; }
  .dbf-indet > i { animation: dbf-fade 2s ease-in-out infinite; transform: translateX(70%); }
  .dbf-dots > i { animation: dbf-fade 1.6s ease-in-out infinite; }
  .dbf-rise, .dbf-pop, .dbf-shake, .dbf-breathe, .dbf-ping { animation: none; }
  .dbf-draw { animation-duration: .01s; animation-delay: 0s; }
  .dbf-liquid, .dbf-liquid * { transition-duration: .01s !important; transition-delay: 0s !important; }
  .dbf-liquid[data-indeterminate="true"] { animation: none; --dbf-p: .5; }
  .dbf-caret { animation: none; }
}
@keyframes dbf-fade { 0%, 100% { opacity: .45; } 50% { opacity: 1; } }
`;
export function ensureFeedbackStyles() {
    injectStyles('db-feedback-styles', CSS);
}
ensureFeedbackStyles();
